import { render, staticRenderFns } from "./PermissionsReportsForm.vue?vue&type=template&id=0b19975f&scoped=true&"
import script from "./PermissionsReportsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsReportsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19975f",
  null
  
)

export default component.exports